import React from "react";

export default function WidgetStatsAnalysisIndicator({ year, month }) {
  return (
    <div style={DEFAULT_STYLE}>
      {year}년 {month}월
    </div>
  );
}

const DEFAULT_STYLE = {
  position: "absolute",
  right: 90,
  top: 50,
  backgroundColor: "#184680",
  color: "white",
  opacity: 0.8,
  fontSize: "16px",
  padding: 5,
  borderRadius: 4,
};
